import { jwtDecode } from 'jwt-decode';

const MILLISECONDS_PER_SECOND = 1000;

interface ExpiringTokenPayload {
  exp?: number;
}

/**
 * Vrai si le jeton est décodable et que son échéance (`exp`, en secondes) est
 * dans le futur. Un jeton absent, illisible ou sans échéance est refusé.
 *
 * La signature n'est pas vérifiée : c'est le rôle de l'API. Ce contrôle évite
 * seulement de considérer (ou de transmettre) une session déjà périmée.
 */
export function isTokenUnexpired(
  token: string | null | undefined,
  now: number = Date.now()
): token is string {
  if (!token) {
    return false;
  }
  try {
    const { exp } = jwtDecode<ExpiringTokenPayload>(token);
    return typeof exp === 'number' && exp * MILLISECONDS_PER_SECOND > now;
  } catch {
    return false;
  }
}
